// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/dev.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "api.devplan.types.dev";

export interface DevConfig {
  defaultCommands: IdeCommand[];
  defaultMcpServers: McpServer[];
  planRepoPath: string;
  specsEnabledIdes: string[];
}

export interface IdeCommand {
  /** Name of the rule backing that command. */
  ruleName: string;
}

export interface McpServer {
  name: string;
  type: { $case: "http"; value: HttpMcpServer } | { $case: "stdio"; value: StdioMcpServer } | undefined;
}

export interface HttpMcpServer {
  url: string;
}

export interface StdioMcpServer {
  command: string;
  args: string[];
}

function createBaseDevConfig(): DevConfig {
  return { defaultCommands: [], defaultMcpServers: [], planRepoPath: "", specsEnabledIdes: [] };
}

export const DevConfig: MessageFns<DevConfig> = {
  encode(message: DevConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.defaultCommands) {
      IdeCommand.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.defaultMcpServers) {
      McpServer.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.planRepoPath !== "") {
      writer.uint32(26).string(message.planRepoPath);
    }
    for (const v of message.specsEnabledIdes) {
      writer.uint32(34).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DevConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDevConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.defaultCommands.push(IdeCommand.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.defaultMcpServers.push(McpServer.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.planRepoPath = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.specsEnabledIdes.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DevConfig {
    return {
      defaultCommands: globalThis.Array.isArray(object?.defaultCommands)
        ? object.defaultCommands.map((e: any) => IdeCommand.fromJSON(e))
        : globalThis.Array.isArray(object?.default_commands)
        ? object.default_commands.map((e: any) => IdeCommand.fromJSON(e))
        : [],
      defaultMcpServers: globalThis.Array.isArray(object?.defaultMcpServers)
        ? object.defaultMcpServers.map((e: any) => McpServer.fromJSON(e))
        : globalThis.Array.isArray(object?.default_mcp_servers)
        ? object.default_mcp_servers.map((e: any) => McpServer.fromJSON(e))
        : [],
      planRepoPath: isSet(object.planRepoPath)
        ? globalThis.String(object.planRepoPath)
        : isSet(object.plan_repo_path)
        ? globalThis.String(object.plan_repo_path)
        : "",
      specsEnabledIdes: globalThis.Array.isArray(object?.specsEnabledIdes)
        ? object.specsEnabledIdes.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.specs_enabled_ides)
        ? object.specs_enabled_ides.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: DevConfig): unknown {
    const obj: any = {};
    if (message.defaultCommands?.length) {
      obj.defaultCommands = message.defaultCommands.map((e) => IdeCommand.toJSON(e));
    }
    if (message.defaultMcpServers?.length) {
      obj.defaultMcpServers = message.defaultMcpServers.map((e) => McpServer.toJSON(e));
    }
    if (message.planRepoPath !== "") {
      obj.planRepoPath = message.planRepoPath;
    }
    if (message.specsEnabledIdes?.length) {
      obj.specsEnabledIdes = message.specsEnabledIdes;
    }
    return obj;
  },

  create(base?: DeepPartial<DevConfig>): DevConfig {
    return DevConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DevConfig>): DevConfig {
    const message = createBaseDevConfig();
    message.defaultCommands = object.defaultCommands?.map((e) => IdeCommand.fromPartial(e)) || [];
    message.defaultMcpServers = object.defaultMcpServers?.map((e) => McpServer.fromPartial(e)) || [];
    message.planRepoPath = object.planRepoPath ?? "";
    message.specsEnabledIdes = object.specsEnabledIdes?.map((e) => e) || [];
    return message;
  },
};

function createBaseIdeCommand(): IdeCommand {
  return { ruleName: "" };
}

export const IdeCommand: MessageFns<IdeCommand> = {
  encode(message: IdeCommand, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ruleName !== "") {
      writer.uint32(10).string(message.ruleName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IdeCommand {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIdeCommand();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ruleName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IdeCommand {
    return {
      ruleName: isSet(object.ruleName)
        ? globalThis.String(object.ruleName)
        : isSet(object.rule_name)
        ? globalThis.String(object.rule_name)
        : "",
    };
  },

  toJSON(message: IdeCommand): unknown {
    const obj: any = {};
    if (message.ruleName !== "") {
      obj.ruleName = message.ruleName;
    }
    return obj;
  },

  create(base?: DeepPartial<IdeCommand>): IdeCommand {
    return IdeCommand.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IdeCommand>): IdeCommand {
    const message = createBaseIdeCommand();
    message.ruleName = object.ruleName ?? "";
    return message;
  },
};

function createBaseMcpServer(): McpServer {
  return { name: "", type: undefined };
}

export const McpServer: MessageFns<McpServer> = {
  encode(message: McpServer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    switch (message.type?.$case) {
      case "http":
        HttpMcpServer.encode(message.type.value, writer.uint32(802).fork()).join();
        break;
      case "stdio":
        StdioMcpServer.encode(message.type.value, writer.uint32(810).fork()).join();
        break;
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): McpServer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMcpServer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.type = { $case: "http", value: HttpMcpServer.decode(reader, reader.uint32()) };
          continue;
        }
        case 101: {
          if (tag !== 810) {
            break;
          }

          message.type = { $case: "stdio", value: StdioMcpServer.decode(reader, reader.uint32()) };
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): McpServer {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      type: isSet(object.http)
        ? { $case: "http", value: HttpMcpServer.fromJSON(object.http) }
        : isSet(object.stdio)
        ? { $case: "stdio", value: StdioMcpServer.fromJSON(object.stdio) }
        : undefined,
    };
  },

  toJSON(message: McpServer): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.type?.$case === "http") {
      obj.http = HttpMcpServer.toJSON(message.type.value);
    } else if (message.type?.$case === "stdio") {
      obj.stdio = StdioMcpServer.toJSON(message.type.value);
    }
    return obj;
  },

  create(base?: DeepPartial<McpServer>): McpServer {
    return McpServer.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<McpServer>): McpServer {
    const message = createBaseMcpServer();
    message.name = object.name ?? "";
    switch (object.type?.$case) {
      case "http": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "http", value: HttpMcpServer.fromPartial(object.type.value) };
        }
        break;
      }
      case "stdio": {
        if (object.type?.value !== undefined && object.type?.value !== null) {
          message.type = { $case: "stdio", value: StdioMcpServer.fromPartial(object.type.value) };
        }
        break;
      }
    }
    return message;
  },
};

function createBaseHttpMcpServer(): HttpMcpServer {
  return { url: "" };
}

export const HttpMcpServer: MessageFns<HttpMcpServer> = {
  encode(message: HttpMcpServer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HttpMcpServer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHttpMcpServer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.url = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HttpMcpServer {
    return { url: isSet(object.url) ? globalThis.String(object.url) : "" };
  },

  toJSON(message: HttpMcpServer): unknown {
    const obj: any = {};
    if (message.url !== "") {
      obj.url = message.url;
    }
    return obj;
  },

  create(base?: DeepPartial<HttpMcpServer>): HttpMcpServer {
    return HttpMcpServer.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HttpMcpServer>): HttpMcpServer {
    const message = createBaseHttpMcpServer();
    message.url = object.url ?? "";
    return message;
  },
};

function createBaseStdioMcpServer(): StdioMcpServer {
  return { command: "", args: [] };
}

export const StdioMcpServer: MessageFns<StdioMcpServer> = {
  encode(message: StdioMcpServer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.command !== "") {
      writer.uint32(10).string(message.command);
    }
    for (const v of message.args) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StdioMcpServer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStdioMcpServer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.command = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.args.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StdioMcpServer {
    return {
      command: isSet(object.command) ? globalThis.String(object.command) : "",
      args: globalThis.Array.isArray(object?.args) ? object.args.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: StdioMcpServer): unknown {
    const obj: any = {};
    if (message.command !== "") {
      obj.command = message.command;
    }
    if (message.args?.length) {
      obj.args = message.args;
    }
    return obj;
  },

  create(base?: DeepPartial<StdioMcpServer>): StdioMcpServer {
    return StdioMcpServer.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StdioMcpServer>): StdioMcpServer {
    const message = createBaseStdioMcpServer();
    message.command = object.command ?? "";
    message.args = object.args?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
